import React from 'react';
import { useSelector } from 'react-redux';
// redux
import { selectPassengersList  } from 'redux/passengers/passengersSelectors';
// hooks
import { useAuth, useWindowDimensions } from 'hooks';
// components
import PassengerItem from 'components/PassengerItem/PassengerItem';
import PassengerItemMobile from 'components/PassengerItem/PassengerItemMobile';
// scss
import './PassengersList.scss';

const PassengersList = ({ selectedPassengersIds, setSelectedPassengersIds, totalPassengers, totalTickets }) => {
  const passengersList = useSelector(selectPassengersList);
  const { isSuperAdmin } = useAuth();
  const { is1440 } = useWindowDimensions();
  const isPassengersListNotEmpty = passengersList?.length > 0;

  function handleSelect(id) {
    setSelectedPassengersIds(prev => {
      if (prev?.includes(id)) {
        // Видаляємо id з масиву
        return prev?.filter(passengerId => passengerId !== id);
      } else {
        // Додаємо id в масив
        return [...prev, id];
      }
    });
  }
  function handleSelectAll() {
    if (selectedPassengersIds?.length === passengersList?.length) {
      // Якщо всі пасажири обрані, очищаємо масив
      setSelectedPassengersIds([]);
    } else {
      // Якщо не всі пасажири обрані, додаємо всіх пасажирів
      const allPassengerIds = passengersList?.map(
        passenger => passenger?.passenger_id
      );
      setSelectedPassengersIds(allPassengerIds);
    }
  }

  return (
    <>
      {is1440 && (
        <div className="fixed-box">
          <div className="total-box">
            {Boolean(totalPassengers) && <p>Кількість пасажирів: <span>{totalPassengers}</span></p>}
            {Boolean(totalTickets) && <p>Кількість квитків: <span>{totalTickets}</span></p>}
          </div>
          <div className="passengers__titles">
            <div className="passenger__checkbox-wrap">
              <input
                className="passenger__checkbox"
                type="checkbox"
                name="passenger"
                id="all-passenger"
                checked={selectedPassengersIds?.length === passengersList?.length}
                onChange={handleSelectAll}
              />
              <label
                className="passenger__checkbox-label"
                htmlFor="all-passenger"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </label>
            </div>
            <span className="passenger__departure-date">Дата виїзду</span>
            <span className="passenger__full-name">ПІБ Пасажира</span>
            <span className="passenger__phone">Номер телефону</span>
            <span className="passenger__ticket-price">Ціна квитка</span>
            <span className="passenger__number-of-tickets">К-сть квитків</span>
            <span className="passenger__seats">Місце</span>
            <span className="passenger__direction">Напрям</span>
            <span className="passenger__comment">Коментар</span>
            {isSuperAdmin && <span className="passenger__creator-name">Від кого пасажир</span>}
          </div>
        </div>
      )}
      {!is1440 && isPassengersListNotEmpty &&
        <div className="passenger__checkbox-wrap passenger__checkbox-wrap--mobile">
          <input
            className="passenger__checkbox"
            type="checkbox"
            name="passenger"
            id="all-passenger"
            checked={selectedPassengersIds?.length === passengersList?.length}
            onChange={handleSelectAll}
          />
          <label className="passenger__checkbox-label" htmlFor="all-passenger" >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" >
              <path d="M11.6673 3.5L5.25065 9.91667L2.33398 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </label>
           Обрати всі
        </div>

      }
      <ul className="passengers__list">
        {is1440 && passengersList && passengersList?.map((i, idx) => ( <PassengerItem key={i?.passenger_id || idx} data={i} idx={idx} selectedPassengersIds={selectedPassengersIds} handleSelect={handleSelect} isSuperAdmin={isSuperAdmin} /> ))}
        {!is1440 && passengersList && passengersList?.map((i, idx) => ( <PassengerItemMobile key={i?.passenger_id || idx} data={i} idx={idx} selectedPassengersIds={selectedPassengersIds} handleSelect={handleSelect} isSuperAdmin={isSuperAdmin} /> ))}
      </ul>
    </>
  );
};

export default PassengersList;
